import { GROUP_TO_CATEGORY, type TrendsGroup } from "../components/costConstants";
import { useDatabricksCostTrendsByProduct } from "./useDatabricksSummary";
import { useDatabricksPastChartData } from "./useDatabricksChartData";

interface PastTrendsResult {
  chartData: Record<string, number | string | null>[];
  groups: string[];
  productsByGroup: Record<string, string[]>;
  isLoading: boolean;
  error: unknown;
}

// Fetches a single `/cost/trends/by-product?category=…` query — `total` when no
// category is selected, otherwise the selected category — and shapes it for
// the Past view's chart. Group breakdown for the totals tile is sourced from
// `/cost/overview`'s `category_breakdown` directly (see DatabricksCostPastView).
export const useDatabricksPastTrends = (
  startDate: string,
  endDate: string,
  granularity: "day" | "week" | "month",
  selectedGroup: TrendsGroup | null
): PastTrendsResult => {
  const category = selectedGroup ? GROUP_TO_CATEGORY[selectedGroup] : "total";

  const trendsQuery = useDatabricksCostTrendsByProduct({
    start_date: startDate,
    end_date: endDate,
    granularity,
    category,
  });

  const { chartData, groups, productsByGroup } = useDatabricksPastChartData(
    trendsQuery.data,
    selectedGroup
  );

  return {
    chartData,
    groups,
    productsByGroup,
    isLoading: trendsQuery.isLoading,
    error: trendsQuery.error,
  };
};
